// extracted by mini-css-extract-plugin
module.exports = {"TaskList":"TaskList--3v2Wh","List":"List--3dKPe"};